<div class="sk-m-singleTextImg {{basic.style.type}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
            {{if style.isShowTitle == '1'}}
                <% include('../common/title.art', {title: basic.title}) %>
            {{/if}}
            {{if !content || (!content.imgUrl && !content.title && !content.desc)}}
                      <% include('../common/nodata.art') %>
             {{else}}
             {{if basic.style.type != 'textFloatBox' && content.linkType != 'none' && !isDesign}}
                  <a class="goto-link" target="_blank" href="{{content.link}}" style="display:block">
             {{/if}}
                <div class="mainBox">
                    <div class="imgBox">
                        {{if content.imgUrl}}
                            <img src="{{content.imgUrl}}" alt="">
                        {{/if}}
                    </div>
                    <div class="contentBox">
                        <div class="title {{style.titleStyle.styleType == 'default'?'medium':style.titleStyle.fontSize}}" style="{{style.titleStyle.styleType == 'default'?'': 'color:'+ style.titleStyle.color}}">{{content.title}}</div>
                        <div class="content {{style.descStyle.styleType == 'default'?'medium':style.descStyle.fontSize}}" style="{{style.descStyle.styleType == 'default'?'': 'color:'+ style.descStyle.color}}">{{content.desc}}</div>
                        {{if basic.style.type == 'textFloatBox' && content.buttonText && style.button.styleType !== 'hide' }}
                        <div class="buttonBox {{style.button.styleType == 'default'?'medium':style.button.fontSize}}">
                            <span class="button" style="{{style.button.styleType == 'default'?'': 'color:'+ style.button.color}};background-color:{{style.button.backgroundColor}};background-image:url('{{style.button.imgUrl}}')">
                                {{if content.linkType != 'none' && !isDesign}}
                                <a class="goto-link" target="_blank" href="{{content.link}}">
                                {{/if}}
                                {{content.buttonText}}
                                {{if content.linkType != 'none' && !isDesign}}
                                </a>
                                {{/if}}
                            </span>
                        </div>
                        {{/if}}
                    </div>
                </div>
                {{if basic.style.type != 'textFloatBox' && content.linkType != 'none' && !isDesign}}
                    </a>
                {{/if}}
            {{/if}}
</div>